var _rect, _path, _path2, _ellipse, _path3, _path4, _path5, _polygon, _path6, _path7, _ellipse2, _ellipse3, _path8, _polygon2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect2, _rect3, _path17, _path18, _path19, _polygon3, _path20, _path21, _path22, _path23, _path24, _rect4, _path25, _rect5, _rect6, _rect7, _rect8, _path26, _polygon4, _rect9, _polygon5, _rect10, _circle, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#38 weather") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 201.64,
    y: 51.86,
    width: 108.88,
    height: 158.92,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.3,131.52a10.16,10.16,0,0,0-13-13.48c-8.55,3.38-17.64,9.59-22.62,21-11.2,25.59-5.15,39,6,41.77S127.24,141,127.24,141Z",
    fill: "#F7D8E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.3,131.52a10.16,10.16,0,0,0-13-13.48c-8.55,3.38-17.64,9.59-22.62,21-11.2,25.59-5.15,39,6,41.77S127.24,141,127.24,141Z",
    fill: "#fff",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.92,
    cy: 260.35,
    rx: 144.69,
    ry: 14.69,
    fill: "#a8edea",
    opacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.58,250.53s-8.29-2.23-10.13-9.94c0,0,12.83-2.64,13.25,10.61Z",
    fill: "#F7D8E4",
    opacity: 0.58
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.59,249.7s-5.82-9.13-.76-17.7c0,0,9.78,6.15,5.49,17.7Z",
    fill: "#F7D8E4",
    opacity: 0.73
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.09,249.7s3-9.68,12.25-11.55c0,0,1.76,6.27-5.94,11.55Z",
    fill: "#F7D8E4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "85.08 249.51 86.8 260.99 97.38 260.99 98.89 249.51 85.08 249.51",
    fill: "#24285b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.46,255.69s-1.46,4.05-5.12,4.36-4.62,3.89-1.33,4.82,11.78-3.3,11.78-3.3l-.24-5.28Z",
    fill: "#F7D8E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.51,255.69s1.46,4.05,5.12,4.36,4.62,3.89,1.33,4.82-11.78-3.3-11.78-3.3l.24-5.28Z",
    fill: "#F7D8E4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123,
    cy: 87.51,
    rx: 57.95,
    ry: 6.8,
    fill: "#ffd200"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123,
    cy: 87.51,
    rx: 57.95,
    ry: 6.8,
    opacity: 0.08
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.45,92.65s2.41,5.1,2.81,8.93a2.83,2.83,0,0,1-2.53,3.12,6.25,6.25,0,0,1-6.22-2.72l-3.29-4a5.05,5.05,0,0,1,.22-5.84C137.62,88.85,143.14,89.47,144.45,92.65Z",
    fill: "#f4a28c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "136.46 98.87 135.13 117.3 145.34 117.31 142.29 104.23 136.46 98.87",
    fill: "#f4a28c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.22,93.36a22.39,22.39,0,0,1-5,1.42A4.7,4.7,0,0,1,140,99.62a3.82,3.82,0,0,1-3.8,3l-2.43-6.83a5.76,5.76,0,0,1,1-5.81,21.23,21.23,0,0,1,1.86-2c1.67-1.5,5-1.26,6.28-3.23a1.36,1.36,0,0,1,2.33.09c1.07,1.95,1.91,5.34-.47,7.51A5.71,5.71,0,0,1,143.22,93.36Z",
    fill: "#24285b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5,99.26s-.79-2-2.26-1.3-.35,3.65,1.83,3.15Z",
    fill: "#f4a28c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.8,95.94,148,97.43A.91.91,0,0,1,148,99l-1.88,1.13Z",
    fill: "#f4a28c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.37,104.6a6.94,6.94,0,0,1-3.32-1.59s-.66,4,4.2,5.34Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148,97.43l-2.22-1.49h0c-.69-1.89-1.35-3.3-1.35-3.3v0l.27-.19c2.38-2.17,1.54-5.56.47-7.51a1.36,1.36,0,0,0-2.33-.09c-1.27,2-4.61,1.73-6.28,3.23a21.23,21.23,0,0,0-1.86,2,5.76,5.76,0,0,0-.95,5.81l2.43,6.83h0l-1.06,14.64h10.21l-2.53-10.85-.44-1.86h0a8.67,8.67,0,0,0,2.36.1,2.84,2.84,0,0,0,2.53-3.12,15,15,0,0,0-.35-2l1.08-.64A.91.91,0,0,0,148,97.43Z",
    opacity: 0.08
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M220.54,110.48l8,7-2,2.71a23.09,23.09,0,0,0-4.24,17c2,13.86,2.56,39.9-20.67,46.19l.55-24.45,8.05-40.36Z",
    opacity: 0.08
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.22,116.86h21.91c6.49,0,11.49.24,17.17,3.38,13.67,7.55,20.15,24.81-.29,77.48h-45.5S85,118.06,128.22,116.86Z",
    fill: "#F7D8E4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.56,149.59A10.77,10.77,0,0,1,121,138.77V56.63h1.72v82.14a9,9,0,0,0,8.23,9.12,8.84,8.84,0,0,0,9.45-8.81v-5.5a.86.86,0,0,1,.86-.87h0a.87.87,0,0,1,.86.87v5.5A10.57,10.57,0,0,1,130.56,149.59Z",
    fill: "#24285b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 119.27,
    y: 26.38,
    width: 5.22,
    height: 20.71,
    rx: 2.61,
    ry: 2.61,
    fill: "#ffd200"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119.27,
    y: 26.38,
    width: 5.22,
    height: 20.71,
    rx: 2.61,
    ry: 2.61,
    opacity: 0.08
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M181,87.42S172.23,38.12,123,38.11h0c-49.23,0-57.95,49.31-57.95,49.31l15.86-2a332,332,0,0,1,87.15.3Z",
    fill: "#ffd200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.85,126.34a5.6,5.6,0,0,1,3.47-6.72,3.1,3.1,0,0,1,4.1,1.76c2.28,4.24.2,9.47-3.55,10.08a3,3,0,0,1-3.3-2.29Z",
    fill: "#f4a28c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M121.51,197.72l7.87,58H139l.55-31.22a21.3,21.3,0,0,1,11.52-18.53L167,197.72Z",
    fill: "#24285b"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.01 197.72 163.94 255.69 153.95 255.69 145.34 205.95 167.01 197.72",
    fill: "#24285b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M155,127a8.71,8.71,0,0,1,12.35-6.77c4.92,2.37,10.32,7.1,13,16.51a158.81,158.81,0,0,0,7.08,19.79,4.53,4.53,0,0,0,8.43-.38l9.77-28.89,8.9,1.84s3.55,40.32-18.57,50.09C175.85,188.08,151,158,155,127Z",
    fill: "#F7D8E4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M155,127a8.71,8.71,0,0,1,12.35-6.77c4.92,2.37,10.32,7.1,13,16.51a158.81,158.81,0,0,0,7.08,19.79,4.53,4.53,0,0,0,8.43-.38l9.77-28.89,8.9,1.84s3.55,40.32-18.57,50.09C175.85,188.08,151,158,155,127Z",
    fill: "#fff",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.47,151.13l14.78-23.23,4.38,3.59-.61,7.59s-.93,34.08-16.39,41.44l-3.26-6.38A23.21,23.21,0,0,1,102.47,151.13Z",
    fill: "#F7D8E4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.47,151.13l14.78-23.23,4.38,3.59-.61,7.59s-.93,34.08-16.39,41.44l-3.26-6.38A23.21,23.21,0,0,1,102.47,151.13Z",
    fill: "#fff",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M207.31,127.62s.72-2.93,5.24-6.16,9.57,1.3,2,7.65Z",
    fill: "#f4a28c"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 209.36,
    y: 106.81,
    width: 10.76,
    height: 17.94,
    transform: "translate(102.05 -100.6) rotate(34.16)",
    fill: "#ffd200"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M91.75,149.64s43.14,18.65,94,3c0,0-3.95-10.09-6.21-18.21s-9.41-13.43-14-15c0,0-4.75-3.35-20.39-2.53l-10.11-.13s-10.15,0-12.13.63a20.26,20.26,0,0,0-10.37,3.33S97.31,126.86,91.75,149.64Z",
    opacity: 0.08
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 258.02,
    y: 66.69,
    width: 33.76,
    height: 11,
    fill: "#c9c9c9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 258.02,
    y: 87.94,
    width: 33.76,
    height: 11,
    fill: "#c9c9c9",
    opacity: 0.36
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 219.85,
    y: 117.31,
    width: 71.92,
    height: 74.86,
    fill: "#c9c9c9",
    opacity: 0.36
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 281.68,
    y: 154.43,
    width: 28.85,
    height: 61.7,
    opacity: 0.08
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M244.56,81.54a4.46,4.46,0,0,0-1.47.27,6.8,6.8,0,0,0-5.91-5.19,8.22,8.22,0,0,0,.16-1.58,8.35,8.35,0,1,0-16.69,0,8.76,8.76,0,0,0,.15,1.55h-.15a6.8,6.8,0,0,0,0,13.6h23.91a4.32,4.32,0,0,0,0-8.64Z",
    fill: "#c9c9c9"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "228.02 90.18 224.35 97.34 230.19 97.31 227.86 104.74 236.02 93.88 230.19 93.84 233.35 89.94 228.02 90.18",
    fill: "#c9c9c9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 271.11,
    y: 165,
    width: 76,
    height: 61.7,
    fill: "#f2f2f2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "307.86 180.24 287.7 211.46 328.03 211.46 307.86 180.24",
    fill: "#c9c9c9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 306.11,
    y: 189.79,
    width: 3.5,
    height: 12.13,
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.05,
    cy: 205.63,
    r: 1.94,
    fill: "#f2f2f2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 278.99,
    y: 171.38,
    width: 17.12,
    height: 6.13,
    opacity: 0.08
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.9b79c24ed3de4d643a9af05f266c64c0.svg";
export { ForwardRef as ReactComponent };